import { render, staticRenderFns } from "./variant.PD-10913.vue?vue&type=template&id=64be256c"
import script from "./variant.PD-10913.vue?vue&type=script&lang=js"
export * from "./variant.PD-10913.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports